export enum CdlClassType {
  Unknown = 0,
  None = 1,
  ClassA = 2,
  ClassB = 3,
  ClassC = 4
}

export const CdlClassTypeMapping: Record<CdlClassType, string> = {
  [CdlClassType.Unknown]: 'Unknown',
  [CdlClassType.None]: 'None',
  [CdlClassType.ClassA]: 'Class A',
  [CdlClassType.ClassB]: 'Class B',
  [CdlClassType.ClassC]: 'Class C'
};
